import { render, staticRenderFns } from "./WarrantyDispatchSection.vue?vue&type=template&id=1dd666eb&scoped=true"
import script from "./WarrantyDispatchSection.vue?vue&type=script&lang=js"
export * from "./WarrantyDispatchSection.vue?vue&type=script&lang=js"
import style0 from "./WarrantyDispatchSection.vue?vue&type=style&index=0&id=1dd666eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd666eb",
  null
  
)

export default component.exports